<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
     <span class="mr-lg-4">
      {{ this.adminuser }}
    </span>
    </template>
    <template slot="dropdown" >
      
      <b-dropdown-item   @click="editProfile = true" data-toggle="tooltip" title="Update Profile!">
        <i class="fa fa-user" /> Update Profile</b-dropdown-item>
      <b-dropdown-item   @click="changepass = true"  data-toggle="tooltip" title="Change Password!">
        <i class="fa fa-key" /> Change Password</b-dropdown-item>
      <b-dropdown-item   @click="logout"  data-toggle="tooltip" title="Logout!">
        <i class="fa fa-lock" /> Logout</b-dropdown-item>
       

       <b-modal title="Update User Profile" v-model="editProfile" @ok="editProfile = false" hide-footer>
          <template slot="modal-header" slot-scope="{ close }">
          <h5>Update User Profile</h5>
          </template>
          <template slot="default" slot-scope="{ hide }">
             <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
                <b-form-group
                  label="First Name"
                  :label-cols="3" >
                  <b-form-input type="text" name="First Name" v-model="customer.firstname" maxlength="10"   v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-1.first name') }" placeholder="Enter your First Name">
                  </b-form-input>

                  <span style="width:240px" v-show="errors.has('form-1.first name')" class="help text-danger">{{ errors.first('form-1.first name') }}</span>                 
                </b-form-group>
                <b-form-group
                  label="Last Name"
                  :label-cols="3" >
                  <b-form-input type="text" name="Last Name" v-model="customer.lastname" maxlength="10"   v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-1.last name') }" placeholder="Enter your Last Name">
                  </b-form-input>

                  <span style="width:240px" v-show="errors.has('form-1.last name')" class="help text-danger">{{ errors.first('form-1.last name') }}</span>                 
                </b-form-group>
                  
                  <b-form-group
                  label="Mobile Number"
                  :label-cols="3" >
                  <b-form-input type="text" name="mobile number"  v-model="customer.mobileno" maxlength="10" v-validate="'required|digits:10'" :class="{'input': true, 'text-danger': errors.has('form-1.mobile number') }" placeholder="Enter Mobile Number">
                  </b-form-input>
                  <span style="width:240px" v-show="errors.has('form-1.mobile number')" class="help text-danger">{{ errors.first('form-1.mobile number') }}</span>                 
                </b-form-group>
                   
                 
                <div slot="footer" class="text-right">
                  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button>
                  <b-button  size="sm" variant="danger" @click="editcancel()">cancel</b-button>
                </div>
              </b-form>
          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
            <!-- Button with custom close trigger value -->
          </template>
         
      </b-modal> 
      <b-modal title="Change Password" size="md" v-model="changepass" @ok="changepass = false" hide-footer>
        <template slot="modal-header" slot-scope="{ close }">
        <h5>Change Password</h5>
        </template>
        <template slot="default" slot-scope="{ hide }">
          <form @submit.prevent="validateForm4('form-4')" data-vv-scope="form-4">
            <div class="modal-background"></div>
            <div class="modal-card">
              <section class="modal-card-body">
                <div class="field">
                  <p class="control">
                    <b-form-input class="input" type="password"  v-model="customer.password" name="password" minlength="6"  id="orignalpass" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-4.password') }"
                      placeholder="Enter New password" />
                    <code v-show="errors.has('form-4.password')" class="help text-danger">{{ errors.first('form-4.password') }}</code>
                     <input type="checkbox" @click="showorignalpass()">&nbsp;Show Password
                  </p>

                  <p class="control">
                    <b-form-input class="input" type="password" id="reenter" v-model="customer.repassword" name="password" minlength="6"   v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-4.password') }"
                      placeholder="Re-Enter password" />
                    <code v-show="errors.has('form-4.password')" class="help text-danger">{{ errors.first('form-4.password') }}</code>
                     <input type="checkbox" @click="showreenterdpass()"> &nbsp;Show  Re-Enterd Password
                  </p>
                </div>
              </section>
              <footer class="text-right">
                <b-button size="sm" variant="primary" type="submit" class="mr-4">Update</b-button>
                 <b-button size="sm" variant="danger" @click="cancel()" >
            Cancel
          </b-button>
              </footer>
            </div>
          </form>
        </template>
        <template slot="modal-footer" slot-scope="{ cancel }">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button size="sm" variant="danger" @click="cancel()" style="display:none">
            Cancel
          </b-button>
          <!-- Button with custom close trigger value -->
        </template>
      </b-modal>
    </template>
  </AppHeaderDropdown>

     
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { 
      itemsCount: 42,
      email: '',
      adminuser:'',
      editProfile:false,
       customer:{},
       firstname:'',
       lastname:'',
       mobileno:'',
       repassword:'',
       password:'',
       
      changepass:false,
      get codUser() {
        return localStorage.getItem('Coduser') || '';
      }
    }

  },
  created() {
       this.getuserdetails()
  },
  methods: {
    getuserdetails: function() {
      var userData = localStorage.getItem('userData')
      if (userData) {
        var userInfo = JSON.parse(userData)
        // console.log('coddd',userInfo);
        let setHeader=JSON.parse(localStorage.getItem('userData'));
        Vue.http.headers.common['x-access-token']  = setHeader.token;
        this.email = userInfo.sysemailid;
        this.customer.firstname = userInfo.userfirstname;
        this.customer.lastname = userInfo.userlastname;
        this.customer.mobileno = userInfo.usermobilenumber;
        
        this.adminuser=userInfo.userfirstname+' '+userInfo.userlastname;
        if (this.email !== '') {} else {
          //this.$router.push('login')
        }
      } else {
        this.$router.push('login')
      }
    },
    //  validateForm(scope) {
     
    //   this.updateuserprofile();
    // }, 
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.updateuserprofile();
        }
      });
    },
     
    validateForm4(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.changeAgentPassword();
        }
      });
    },
     
     showorignalpass: function() {
        var x = document.getElementById("orignalpass");
  if (x.type === "password") {
    x.type = "text";
  } else {
    x.type = "password";
  }
    },


showreenterdpass() {
  var x = document.getElementById("reenter");
  if (x.type === "password") {
    x.type = "text";
  } else {
    x.type = "password";
  }
},

    changeAgentPassword: function() {
      var result = [];
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
       var sysusermasterid1=userInfo.sysusermasterid;
      var passwObj = {
        syspassword: `${this.customer.password}`,
       
        sysusermasterid: sysusermasterid1,
      };
      if ( this.customer.password == this.customer.repassword) {
         this.$http
          .post(
            `${CONSTANTS.MIGRATION_API_URL}/changeuserpassword`,
            passwObj
          ).then(result => {
           if (result.body.returnmsg === "Successful") {
            alert("Password updated successfully");
            // this.$router.push('login')
            this.changepass = false;
            this.customer = {};
            this.logout();
            
          }
          else
          {
            alert(result.body.returnvalue);
           
          }
          })
          .catch(ex => {
            console.log("error", ex);
          });
       
      }
      else
      {
        alert("Password And Re-Entered Password Is Not Matching");
      }
    },
   
    logout: function() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      // alert("check")
      localStorage.setItem('userData', '')
      localStorage.setItem('activeTime', '')
      localStorage.setItem('Coduser', '')
      window.location.href ="/login";
      // this.$router.push('/login')
      

      // const obj = {
      //   sysusermasterid: `${userInfo.sysusermasterid}`,
      // };

      // this.$http
      //   .post(
      //     `${CONSTANTS.MIGRATION_API_URL}/sysuserlogout`,
      //     obj
      //   )
      //   .then((result) => {
      //      if(result.body.returnmsg == 'successful'){
      //       localStorage.setItem('userData', '')
      //       localStorage.setItem('activeTime', '')
      //       localStorage.setItem('Coduser', '')
      //       localStorage.setItem('country','')
      //       this.$router.push('/login')
      //      }
      //      else{

      //       alert("something went wrong, please try again")

      //      }
      //   })
      
    },
     editcancel: function() {
      this.customer = {};
      this.editProfile = false;
    },
     cancel:function() {
      this.customer = {};
      this.changepass = false;
    },
    
   updateuserprofile: function() { 
   
       
      var result = [];
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      var sysusermasterid1=userInfo.sysusermasterid;
      var Obj = {
        userfirstname: `${this.customer.firstname}`,
        userlastname: `${this.customer.lastname}`,
        usermobilenumber:`${this.customer.mobileno}`,
        sysusermasterid: sysusermasterid1,
       
      };  
      // console.log(Obj);
      
      if (this.customer.firstname !== "" &&this.customer.lastname !== "" && this.customer.mobileno !== "") {
        
        this.$http
          .post(
            `${CONSTANTS.MIGRATION_API_URL}/updateuserprofile`,
            Obj
          ).then(result => {
           if (result.body.returnmsg === "Successful") {
            alert("updated successfully");
            this.editProfile = false;
            this.customer = {};
            this.logout();

           
          }
          else
          {
            alert(result.body.returnvalue);
          }
         

           
          })
          .catch(ex => {
            console.log("error", ex);
          });
      }
    },   

  }
}
</script>
